import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { Popover } from '../../popup/popup';
import { Button } from '../buttons';

const ExportButtonPageHeader = ({ link }) => {
  const content = (
    <>
      <a href={link} target="_blank">
        <FeatherIcon size={16} icon="file" />
        <span>CSV</span>
      </a>
    </>
  );
  return (
    <Popover placement="bottomLeft" content={content} trigger="click">
      <Button size="small" style={{ backgroundColor: '#089227', borderColor: '#089227', color: '#fff' }}>
        <FeatherIcon icon="download-cloud" size={14} />
        Export
      </Button>
    </Popover>
  );
};

export { ExportButtonPageHeader };
